<template>
    <!-- note: explicit null check is intentional: 
     false is a valid result, null is the absence of one -->
    <DsBadge
        v-if="isVerified !== null"
        :class="isVerified ? 'text-ds-green-600' : 'text-content-primary'"
        :icon="isVerified ? 'fa-solid fa-check-circle' : 'fa-solid fa-exclamation-triangle'"
        :text="isVerified ? 'Verified' : 'Unverified'"
        :variant="isVerified ? 'success' : 'error'"
    />
</template>

<script setup lang="ts">
import DsBadge from '@/components/design-system/badge/DsBadge.vue';
import type { PayoffVerifiedStatus } from '@/interfaces/payoff/payoff-order.types';

defineProps<{
    isVerified: PayoffVerifiedStatus;
}>();
</script>
